export default __webpack_public_path__ + "5af73ee5eda953472c3a59e139c88128.svg";